import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { FirstVisitPlaceEntity } from 'src/entities/FirstVisitPlace.entity';

const requestPath = (startOn: string) => `/api/v5/plannings/past_order_operations/${startOn}/first_visits`;

export const useFirstVisitsQueryV5 = (startOn: string, shiftTruckIds: number[]) => {
  // queryKey / body / enabled の全箇所で同一の sortedIds を使い、キャッシュキーと
  // リクエスト内容を決定論的に揃える。
  const sortedIds = [...shiftTruckIds].sort((a, b) => a - b);
  return useQuery({
    queryKey: ['useFirstVisitsQueryV5', { startOn, shiftTruckIds: sortedIds }],

    queryFn: async () => {
      const { data } = await axios.post<FirstVisitPlaceEntity[]>(
        requestPath(startOn),
        { shift_truck_ids: sortedIds },
      );
      return data;
    },

    enabled: !!startOn && sortedIds.length > 0,
    staleTime: Infinity
  });
};
